/* eslint-disable-next-line */
import Swiper from 'swiper/bundle'; // NOSONAR
import SwiperExt from '../swiper';

const { feWp } = window;
const { addFilter, applyFilters } = feWp.hooks;

addFilter( 'b3rg_slider_library', 'b3rg/slider', () => {
  return SwiperExt;
} );

/**
 * Inject Swiper-native breakpoints from the data-swiper named breakpoints.
 *
 * b3rg's block-frontend.js initialises Swiper with only the *current* device's
 * flat settings (e.g. { slidesPerView: 3 }) and no `breakpoints` property, so
 * Swiper never adapts when the viewport is resized.
 *
 * This filter reads all breakpoint keys from data-swiper (mobile,
 * tablet-portrait, tablet-landscape, desktop) and converts them into Swiper's
 * min-width numeric breakpoints using the same pixel values registered via
 * b3rg_slider_breakpoints.
 */
addFilter( 'b3rg_slider_extend', 'b3rg/slider-responsive-breakpoints', ( settings, el ) => {
  // Named max-width map: { mobile:575, 'tablet-portrait':991, 'tablet-landscape':1199, desktop:9999 }
  // Pass the values as the default so the map is always populated even when
  // b3rg-slider.js isn't enqueued (e.g. pages that use custom-block sliders
  // where has_block('b3rg/slider') is false and b3rg-slider.js never loads).
  const namedBpMap = applyFilters( 'b3rg_slider_breakpoints', {
    mobile: 575,
    'tablet-portrait': 991,
    'tablet-landscape': 1199,
    desktop: 9999,
  } );
  const deviceKeys = Object.keys( namedBpMap ); // ordered: mobile → … → desktop

  if ( ! deviceKeys.length ) return settings;

  const sliderOptions = JSON.parse( el.getAttribute( 'data-swiper' ) ) || {};

  // Build Swiper min-width breakpoints from named device keys.
  // Each entry's min-width = (previous device's max-width + 1), or 0 for the first.
  const swiperBreakpoints = {};
  deviceKeys.forEach( ( device, index ) => {
    const deviceSettings = sliderOptions[ device ];
    if ( ! deviceSettings || deviceSettings.destroy ) return;

    const minWidth = index === 0 ? 0 : namedBpMap[ deviceKeys[ index - 1 ] ] + 1;
    swiperBreakpoints[ minWidth ] = deviceSettings;
  } );

  // Only inject if there is more than one breakpoint to avoid overriding
  // sliders that intentionally use a single flat config.
  if ( Object.keys( swiperBreakpoints ).length <= 1 ) return settings;

  return { ...settings, breakpoints: swiperBreakpoints };
} );